import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'monthlyTicketRegistration',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        create_registration: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        add_card_registration: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_card_registration: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        confirm_cash_registration: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        extend_registration: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        change_card_registration: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        confirm_cash_registration_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        extend_registration_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        change_card_registration_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        add_card_registration_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        create_registration_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        update_card_registration_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        confirm_cash_registration_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        change_card_registration_succeed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        extend_registration_succeed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        add_card_registration_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        update_card_registration_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        create_registration_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        reset_form: () =>{
            return {
                isRequesting: false,
                error: null,
                isDone: false,
                data: null,
            };
        },
        cancel_ticket: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        cancel_ticket_success: (state,action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        cancel_ticket_fail: (state,action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;